import { CategoryDisplayConfig, StockCategoryFilter } from '../types/stockCategories';
import {
  ALL_CATEGORIES,
  CATEGORY_SEO_DESCRIPTIONS,
  CATEGORY_SEO_KEYWORDS,
  CATEGORY_HERO_HEADINGS,
  CATEGORY_DISPLAY_NAMES,
  isValidCategory
} from '../config/categoryConfig';

export interface CategorySeoConfig {
  title: string;
  description: string;
  keywords: string[];
  heroHeading: string;
  heroDescription: string;
  canonicalPath: string;
  ogImage: string;
}

const BASE_URL = 'https://wallstreetle.com';
const DEFAULT_OG_IMAGE = `${BASE_URL}/assets/share-link-image.png`;

// SEO categories are imported from central config
export const SEO_CATEGORIES = ALL_CATEGORIES;
export type SeoCategory = typeof SEO_CATEGORIES[number];

export const isSeoCategory = (category: StockCategoryFilter): category is SeoCategory =>
  isValidCategory(category);

export const buildCategorySeoConfig = (
  category: StockCategoryFilter,
  config: CategoryDisplayConfig
): CategorySeoConfig | null => {
  if (!isSeoCategory(category)) {
    return null;
  }

  const longDescription = CATEGORY_SEO_DESCRIPTIONS[category];
  const keywords = CATEGORY_SEO_KEYWORDS[category];
  const canonicalPath = `/${category}`;

  return {
    title: `Wallstreetle | ${CATEGORY_DISPLAY_NAMES[category]} Stock Guessing Game`,
    description: longDescription,
    keywords,
    heroHeading: CATEGORY_HERO_HEADINGS[category] ?? `Wallstreetle | ${CATEGORY_DISPLAY_NAMES[category]} Game`,
    heroDescription: longDescription,
    canonicalPath,
    ogImage: DEFAULT_OG_IMAGE,
  };
};
